import gsap from "gsap";

export default function toggleTeacherBlocks() {
  let button = $('.teacher__goto__button');
  let container = $('.teacher__item');
  let offset = 100;
  if ($(window).width() >= 600) {
    offset = 150;
  } 
  if ($(window).width() >= 1110) {
    offset = 200;
  } 
  for (let i = 0; i < Array.from(button).length; i++) {
    $(button[i]).on('click', function () {
      let id = button[i].getAttribute('data-id');
      let block = $('.teacher__item[data-id="' + id + '"]');
      button.removeClass('active');
      $('.teacher__goto__button[data-id="' + id + '"]').addClass('active');
      gsap.to(container, {opacity: 0, duration: 0.3, onComplete: () => {
        gsap.to(container, {display: 'none', duration: 0});
        let offsetTop = $('.teacher__items').offset().top - offset;
        $('body,html').animate({scrollTop: offsetTop}, 600);
        gsap.to($(block).attr('data-id', $(this).attr('data-id')), {display: 'block', duration: 0, onComplete: () => {
          gsap.to($(block).attr('data-id', $(this).attr('data-id')), {opacity: 1, duration: 0.3});
        }});
      }});
    });
  }
}
toggleTeacherBlocks();